<template>
<ItpBadge
  :value="status"
  :variantMap="$config.statusVariants"
>
  {{ messages[status] || status }}
</ItpBadge>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcStatusBadge extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: String,
  })
  status!: string;

  @Watch('status')
  onStatus(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("status")
  }

  messages!: any;
  ux!: any;
  dataMembers = ['messages', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          archived: this.$fn.pgettext("Status", "Archived"),
          draft: this.$fn.pgettext("Status", "Draft"),
          pending: this.$fn.pgettext("Status", "Pending"),
          retry: this.$fn.pgettext("Status", "Retry"),
          running: this.$fn.pgettext("Status", "Running"),
          completed: this.$fn.pgettext("Status", "Completed"),
          failed: this.$fn.pgettext("Status", "Failed"),
          cancelled: this.$fn.pgettext("Status", "Cancelled"),
          deleted: this.$fn.pgettext("Status", "Deleted"),
          invalid: this.$fn.pgettext("Status", "Invalid"),
        }
        ,
        ux: null,
      },
    }
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("UcStatusBadge", UcStatusBadge);

</script>